module.exports = __webpack_public_path__ + "img/mastercard@2x.a26de336.png";